import * as _ from 'underscore'
import { IReferenceType, IOpObject, IOpData } from '../util/interfaces'
import { Enums } from '../common/enums'
import { Utils } from '../util/utils'
import { OpDescr } from './op-descr'
import { OpDataList, ObjectCustomString } from '../util'
import { OpConfigurationProfileData } from './op-configuration-profile-data'
import { OpScheduleConfiguration } from './op-schedule-configuration'

import { ConvertHelper } from '../../helpers'
import { DataProvider } from '../../helpers/data-provider'
import { OpConfigurationProfileFunction } from './op-configuration-profile-function'

export class OpConfigurationProfile implements IReferenceType, IOpObject {
	//#region Properties

	public idConfigurationProfile: number
	public idConfigurationProfileType: number
	public idDistributor: number
	public name: string
	public idDescr: number
	public idOperatorCreated: number
	public createdTime: Date

	//endregion

	//#region Custom properties

	public functionList: OpConfigurationProfileFunction[] //OpScheduleConfiguration
	public configuationProfileFuntionsDescr: OpDescr

	//endregion

	//#region Navigation properties

	public descr: OpDescr

	//endregion

	constructor(opObj: any) {
		this.fromJSON(opObj)
	}

	//#region IOpChangeState implementation

	public opState: Enums.OpChangeState

	//#endregion

	//#region IReferenceType implementation

	public getReferenceType(): Enums.ReferenceType {
		return Enums.ReferenceType.IdConfigurationProfile
	}
	public getReferenceKey(): number {
		return this.idConfigurationProfile
	}
	public getReferenceValue(): any {
		return this
	}

	//#endregion

	//IOpObject implementation

	public get idObject(): number {
		return this.idConfigurationProfile
	}

	public set idObject(value: number) {
		this.idConfigurationProfile = value
	}

	public dataList: OpDataList<OpConfigurationProfileData> = new OpDataList<OpConfigurationProfileData>()

	public dynamicValues: { Key: string; Value: any }[] = []

	public customFormatString: string

	public toString(): string {
		let customFormatString = ObjectCustomString.getCustomStringFormat(this)

		if (!customFormatString) {
			return this.name
		} else {
			return ObjectCustomString.getObjectCustomString(customFormatString, this)
		}
	}

	//#region IJsonSerializer Implementation

	public fromJSON(opObj: any, compressed: boolean = false): void {
		if (opObj) {
			if (compressed || Utils.isJSONCompressed(opObj)) {
				this.idConfigurationProfile = opObj.I
				this.idConfigurationProfileType = opObj.IPT
				this.idOperatorCreated = opObj.OP
				this.idDistributor = opObj.DS
				this.createdTime = opObj.T != null ? ConvertHelper.stringToDate(opObj.T) : null
				this.name = opObj.N
				this.idDescr = opObj.ID
				this.descr = opObj.D != null ? new OpDescr(opObj.D) : null
				this.opState = opObj.O
				this.functionList = opObj.FL != null ? opObj.FL.map((value) => new OpScheduleConfiguration(value)) : null
				this.configuationProfileFuntionsDescr = opObj.CPFD != null ? new OpDescr(opObj.CPFD) : null
				this.dynamicValues = opObj.DV
				if (opObj.DL != null) {
					this.dataList.push(...opObj.DL.map((data) => new OpConfigurationProfileData(data)))
				}
			} else {
				this.idConfigurationProfile = opObj.ID_CONFIGURATION_PROFILE
				this.idConfigurationProfileType = opObj.ID_CONFIGURATION_PROFILE_TYPE
				this.idOperatorCreated = opObj.ID_OPERATOR_CREATED
				this.idDistributor = opObj.ID_DISTRIBUTOR
				this.name = opObj.NAME
				this.idDescr = opObj.ID_DESCR
				this.descr = opObj._Descr != null ? new OpDescr(opObj._Descr) : null
				this.opState = opObj.OpState
				this.functionList = opObj.FunctionList != null ? opObj.FunctionList.map((value) => new OpScheduleConfiguration(value)) : null
				this.createdTime = opObj.CREATED_TIME != null ? ConvertHelper.stringToDate(opObj.CREATED_TIME) : null
				this.configuationProfileFuntionsDescr = opObj.ConfiguationProfileFuntionsDescr != null ? new OpDescr(opObj.ConfiguationProfileFuntionsDescr) : null
				this.dynamicValues = opObj.dynamicValues
				if (opObj.DataList != null) {
					this.dataList.push(...opObj.DataList.map((data) => new OpConfigurationProfileData(data)))
				}
			}
		}
	}

	public toJSON(compressed: boolean = false): any {
		if (compressed) {
			const resultObj: any = {
				I: this.idConfigurationProfile,
				IPT: this.idConfigurationProfileType,
				OP: this.idOperatorCreated,
				DS: this.idDistributor,
				N: this.name,
				ID: this.idDescr,
				D: this.descr != null ? this.descr.toJSON(compressed) : null,
				S: this.opState,
				FL: this.functionList != null && Array.isArray(this.functionList) && this.functionList.length > 0 ? this.functionList.map((value: OpScheduleConfiguration) => value.toJSON(compressed)) : [],
				T: this.createdTime != null ? ConvertHelper.dateToString(this.createdTime, { netFormat: true }) : null,
				DL: this.dataList.ToJSON(compressed),
				CPFD: this.configuationProfileFuntionsDescr != null ? this.configuationProfileFuntionsDescr.toJSON(compressed) : null,
				DV: this.dynamicValues
			}
			Utils.setJSONCompressedFlag(resultObj)
			return resultObj
		} else {
			return {
				ID_CONFIGURATION_PROFILE: this.idConfigurationProfile,
				ID_CONFIGURATION_PROFILE_TYPE: this.idConfigurationProfileType,
				ID_OPERATOR_CREATED: this.idOperatorCreated,
				ID_DISTRIBUTOR: this.idDistributor,
				NAME: this.name,
				ID_DESCR: this.idDescr,
				_Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
				OpState: this.opState,
				FunctionList: this.functionList != null && this.functionList.length > 0 ? this.functionList.map((value: OpScheduleConfiguration) => value.toJSON(compressed)) : [],
				CREATED_TIME: this.createdTime != null ? ConvertHelper.dateToString(this.createdTime, { netFormat: true }) : null,
				DataList: this.dataList != null ? _.map(this.dataList.toArray(), (item: OpConfigurationProfileData) => item.toJSON()) : null,
				ConfiguationProfileFuntionsDescr: this.configuationProfileFuntionsDescr != null ? this.configuationProfileFuntionsDescr.toJSON() : null,
			}
		}
	}

	//#endregion

	//#endregion

	public static loadNavigationProperties(dataProvider: DataProvider, list: OpConfigurationProfile[]): JQueryPromise<OpConfigurationProfile[]> {
		return Utils.loadDataListNavigationProperties(dataProvider, list)
	}

	public static fromIOpObject(object: IOpObject): OpConfigurationProfile {
		const newObject: OpConfigurationProfile = new OpConfigurationProfile(null)

		newObject.idConfigurationProfile = object.idObject
		newObject.opState = object.opState
		newObject.dataList.push(...object.dataList.toArray().map((d: IOpData) => OpConfigurationProfileData.fromIOpData(d)))

		return newObject
	}

}
